import { App, Button, Form, Input, Modal, Space, Upload } from 'antd'
import { FC, useState } from 'react'
import { UploadFile } from 'antd/es/upload'
import useErrorModal from '../../../hooks/api/use-error-modal'
import useUploadFiles from '../../../hooks/api/use-upload-file'
import {
    useApproveAssemblyTaskMutation,
    useRejectAssemblyTaskMutation,
} from '../../../store/api/tasks-api'
import Task from '../../../types/api/task'

interface CorrectorTaskActionsProps {
    task: Task
}

const CorrectorTaskActions: FC<CorrectorTaskActionsProps> = ({ task }) => {
    const { message } = App.useApp()
    const [approve, approveState] = useApproveAssemblyTaskMutation()
    const [reject, rejectState] = useRejectAssemblyTaskMutation()
    const [uploadFiles, uploadState] = useUploadFiles()
    const [reworkOpen, setReworkOpen] = useState(false)
    const [form] = Form.useForm()

    useErrorModal(approveState, 'Не удалось согласовать сборку')
    useErrorModal(rejectState, 'Не удалось отправить в доработку')

    const isDone = task.taskStatus === 'Завершена' || task.taskStatus === 'Отменена'
    const loading = approveState.isLoading || rejectState.isLoading || uploadState.isLoading

    if (isDone) {
        return null
    }

    const onApprove = async () => {
        const res = await approve(task.documentId)
        if (!('error' in res)) {
            message.success('Сборка согласована')
        }
    }

    const onReworkSubmit = async () => {
        const values = await form.validateFields()
        const fileList = (values.screenshots || []) as UploadFile[]
        let attachmentIds: number[] | undefined

        const local = fileList.filter(file => file.originFileObj)
        if (local.length) {
            const uploaded = await uploadFiles(local)
            attachmentIds = uploaded.data?.map(file => file.id)
        }

        const res = await reject({
            docId: task.documentId,
            comment: values.comment,
            attachmentIds,
        })

        if (!('error' in res)) {
            message.success('Отправлено в доработку')
            setReworkOpen(false)
            form.resetFields()
        }
    }

    return (
        <>
            <Space size={8}>
                <Button type='primary' size='small' loading={loading} onClick={onApprove}>
                    Согласовать
                </Button>
                <Button danger size='small' loading={loading} onClick={() => setReworkOpen(true)}>
                    В доработку
                </Button>
            </Space>

            <Modal
                title='Отправить в доработку'
                open={reworkOpen}
                onCancel={() => setReworkOpen(false)}
                onOk={onReworkSubmit}
                confirmLoading={loading}
                destroyOnClose
                okText='Отправить'
                cancelText='Отмена'
            >
                <Form form={form} layout='vertical'>
                    <Form.Item
                        name='comment'
                        label='Комментарий'
                        rules={[{ required: true, message: 'Укажите комментарий' }]}
                    >
                        <Input.TextArea rows={4} />
                    </Form.Item>
                    <Form.Item
                        name='screenshots'
                        label='Скрины'
                        valuePropName='fileList'
                        getValueFromEvent={e => (Array.isArray(e) ? e : e?.fileList)}
                    >
                        <Upload beforeUpload={() => false} listType='picture' multiple>
                            <Button>Загрузить</Button>
                        </Upload>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default CorrectorTaskActions
